import Navigation from './components/Navigation';
import HeroSection from './components/HeroSection';
import AboutSection from './components/AboutSection';
import NewsSection from './components/NewsSection';
import ContactSection from './components/ContactSection';
import Footer from './components/Footer';
import FloatingButtons from './components/FloatingButtons';
import SEO from './components/SEO';

function App() {
  return (
    <div className='bg-white text-gray-900'>
      <SEO />
      <Navigation />
      <HeroSection />
      <NewsSection />
      <AboutSection />
      <ContactSection />
      <Footer />
      <FloatingButtons />
    </div>
  );
}

export default App;
